import React, { forwardRef, Fragment } from 'react';
import HeroProfile from 'uos/hero'
import EventsList from 'uos/eventList'
import axios from 'axios'
import Qs from 'qs';
import { Row, Col, Card, Collapse, Nav, NavItem, Button, UncontrolledCarousel, NavLink as NavLinkStrap } from 'reactstrap';

import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import projectLogo from '../../assets/test/logo.jpg';
import SingleEventProfile from 'uos/single_event';
import MemberProfile from 'uos/member';
import MainHeaderUser from 'uos/mainHeaderUser'
import HighLightInfo from 'uos/highlightInfo';
import test1 from '../../assets/test/loading_small.jpg';
import test2 from '../../assets/test/loading_small.jpg';
import test3 from '../../assets/test/loading_small.jpg';
import Swal from 'sweetalert2';
import FileInstance from 'uos_admin/fileInstance';
import InfoModal from 'uos/infoModal';
import { getFileUploadUI } from 'uos_admin/uosFileAction';

import sponsor_logo from 'logo/partner.jpg'
import HomeHeroImages from 'uos/hero';
import GalleryShow from 'uos/galleryShow';

const highlightImages_TEMP = [
    {
        src: test1,
        altText: 'Slide 1',
        caption: 'Slide 1',
        header: 'Slide 1 Header',
        key: '1'
    },
    {
        src: test2,
        altText: 'Slide 2',
        caption: 'Slide 2',
        header: 'Slide 2 Header',
        key: '2'
    },
    {
        src: test3,
        altText: 'Slide 3',
        caption: 'Slide 3',
        header: 'Slide 3 Header',
        key: '3'
    }
];

export default class MainPage extends React.Component {

    constructor(props) {
        super(props);
        let pageName = props.pageName;
        let option = "";
        let event_id="";
        let file_id="";
        if (pageName == "single_event") {
            event_id = props.match.params.id;
            option=pageName;
        }
        else if (pageName == "resource") {
            file_id = props.match.params.id;
            option=pageName;
        }
        else {
            option = props.match.params.id;
        }

        let lang = "en";

        if (window.localStorage.getItem("ch_lang")) {
            lang = window.localStorage.getItem("ch_lang");
        }

        this.state = { pageName: pageName, file_id:file_id, option: option, event_id:event_id, collapse_show: 0, collapse: false, home: null, dataLoaded: false, highlightImages: [], lang_version: lang }
    }

    componentDidMount() {
        let option = this.state.option;
        if (option === "all" || option === "highlights" || option === "about_us" || option === "contact_us" || option === "contact_us") {
            let session = window.localStorage;
            axios.post(
                session.ch_action_url + "/action/get_home_configuration",
                Qs.stringify({})
            ).then((res) => {
                if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                } else {
                    let home = res.data.data;
                    this.setState({ home: home, dataLoaded: true });
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.option === "about_us") {
            let element = document.getElementById("about_us");
            element.scrollIntoView({ behavior: 'smooth', block: "start", inline: "nearest" })
        }
        else if (this.state.option === "contact_us") {
            let element = document.getElementById("contact_us");
            element.scrollIntoView({ behavior: 'smooth' })
        }
        else if (this.state.option === "highlights") {
            let element = document.getElementById("highlights");
            element.scrollIntoView({ behavior: 'smooth', block: "start", inline: "nearest" })
        }

    }

    handleMobileToggle() {
        this.setState({ collapse: !this.state.collapse, collapse_show: "" });
    }


    handleHeaderClick(e, option) {
        e.preventDefault();
        let collapse_show = this.state.collapse_show;
        if (collapse_show === option) {
            this.setState({ collapse_show: "" });
            return;
        }
        if (option === "about" || option === "members" || option === "donate") {
            this.setState({ collapse_show: option });
        }
        else if (option === "highlights") {
            this.state({ option: "highlights" });
        }
        else if (option === "events") {
            let url = window.location.origin + "/home/events";
            window.location.href = url;
        }
        else if (option === "resource") {
            let url = window.location.origin + "/resource/0";
            window.location.href = url;
        }
    }

    handleNavClick(e, option) {
        e.preventDefault();
        if (option === "about" || option === "members" || option === "donate") {
            this.setState({ collapse_show: option });
        }
        else if (option === "donate_now") {
            let dom = document.getElementById("pay_now_form_8b4f1fcbb5");
            dom.submit();
        }
        else if (option === "resource") {
            let href = window.location.origin + "/resource/0";
            window.history.pushState({}, 0, href);
            this.setState({ option: option, file_id:"0" });
        }
        else {
            let href = window.location.origin + "/home/" + option;
            window.history.pushState({}, 0, href);
            this.setState({ option: option, collapse:false });
        }
    }

    handleViewSingleEvent(id) {
        let href = window.location.origin + "/single_event/" + id;
        window.location.href=href;
        //window.history.pushState({option:id}, 0, href);
        //this.setState({ option: "single_event", event_id: id });
    }

    goToSponsor() {
        let url = "https://www.morrisarts.org";
        window.open(url, "_blank");
    }

    getNavList(option) {
        if (option === "about") {
            return <Nav pills className="nav-neutral-primary nav-pills-rounded nav-lg flex-column p-3">
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "about_us")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "About Huaxia Chorus" : "基本介绍"}</span>
                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "law")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Huaxia Chorus By-Laws" : "法律法规"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "regulation")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Huaxia Chorus Regulations" : "合唱团规则"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "contact_us")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Contact Us" : "联系我们"}</span>
                    </NavLinkStrap>
                </NavItem>
            </Nav>;
        }
        else if (option === "member") {
            return <Nav pills className="nav-neutral-primary nav-pills-rounded nav-lg flex-column p-3">
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "conductor")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "The Conductor" : "合唱指挥"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "instructor")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "The Vocality Instructors" : "声乐导师"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "advisor")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "The Artistic Advisors" : "艺术顾问"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "committee")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Huaxia Chorus Committee" : "委员会"}</span>
                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "member")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Members" : "成员"}</span>
                    </NavLinkStrap>
                </NavItem>
            </Nav>;

        }
        else if (option === "donate") {
            return <Nav pills className="nav-neutral-primary nav-pills-rounded nav-lg flex-column p-3">
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "donation_introduction")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Introduction" : "捐赠简介"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "donate_now")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Donate Now" : "前往捐赠"}</span>

                    </NavLinkStrap>
                </NavItem>
                <NavItem>
                    <NavLinkStrap
                        href="#/"
                        onClick={(e) => this.handleNavClick(e, "donation_letter")}
                        className="px-4 d-flex align-items-center">
                        <span>{this.state.lang_version === "en" ? "Public Letter To Donor" : "致捐赠者"}</span>
                    </NavLinkStrap>
                </NavItem>

            </Nav>;

        }
    }

    goHomePage(e) {
        e.preventDefault();
        let href = window.location.origin + "/home/all";
        window.location.href = href;
    }

    updateLangVersion() {
        let storage = window.localStorage;
        if (this.state.lang_version === "ch") {
            this.setState({ lang_version: "en" });
            storage.setItem('ch_lang', "en");
        }
        else {
            this.setState({ lang_version: "ch" });
            storage.setItem('ch_lang', "ch");
        }
    }

    render() {
        let isLogin = window.localStorage.getItem('ch_isLogin') === "0" ? false : true;
        return (
            <Fragment>
                <div name="main" style={{ background: "rgb(243 243 245)" }}>
                    <div className="pl-4 pr-4 my-header">
                        <div className="header-nav-wrapper header-nav-wrapper-lg rounded navbar-dark">

                            <div className="app-nav-logo">
                                <span className="d-block d-lg-none">
                                    <button
                                        onClick={() => this.handleMobileToggle()}
                                        className={clsx('navbar-toggler hamburger hamburger--elastic', {
                                            'is-active': this.state.collapse
                                        })}>
                                        <span className="hamburger-box">
                                            <span className="hamburger-inner" />
                                        </span>
                                    </button>
                                </span>
                                <a href="#/"
                                    onClick={(e) => this.goHomePage(e)}
                                    title="Hua Xia Chorus"
                                    className="app-nav-logo">
                                    <div className="app-nav-logo--text">
                                        <span style={{fontSize:"17px"}}>{this.state.lang_version === "en" ? "HuaXia Chinese Chorus of New Jersey" : "新泽西华夏合唱团"}</span>
                                    </div>
                                </a>
                            </div>
                            <div className="header-nav-menu d-none d-lg-block">
                                <ul className="d-flex">
                                    <li name="aboutus" style={{margin:"0px"}}>
                                        <a className="rounded-pill header_a" href="#/" onClick={(e) => e.preventDefault()}>
                                            {this.state.lang_version === "en" ? "About Us" : "关于我们"}
                                            <span className="opacity-5 dropdown-arrow">
                                                <FontAwesomeIcon icon={['fas', 'angle-down']} />
                                            </span>
                                        </a>
                                        <div className="submenu-dropdown">
                                            <div className="shadow-lg bg-white rounded">
                                                {this.getNavList("about")}
                                            </div>
                                        </div>
                                    </li>
                                    <li name="highlight">
                                        <a className="rounded-pill header_a"
                                            href="#/"
                                            onClick={(e) => this.handleNavClick(e, "highlights")}>
                                            {this.state.lang_version === "en" ? "Highlights" : "感动瞬间"}

                                        </a>
                                    </li>
                                    <li name="events">
                                        <a className="rounded-pill header_a"
                                            href="#/"
                                            onClick={(e) => this.handleNavClick(e, "events")}>
                                            {this.state.lang_version === "en" ? "Events" : "动态"}

                                        </a>
                                    </li>
                                    <li name="resource">
                                        <a className="rounded-pill header_a"
                                            href="#/"
                                            onClick={(e) => this.handleNavClick(e, "gallery")}>
                                            {this.state.lang_version === "en" ? "Gallery" : "图库"}
                                        </a>
                                    </li>
                                    {isLogin && <li name="resource">
                                        <a className="rounded-pill header_a"
                                            href="#/"
                                            onClick={(e) => this.handleNavClick(e, "resource")}>
                                            {this.state.lang_version === "en" ? "Resources" : "资源"}

                                        </a>
                                    </li>}

                                    <li name="member">
                                        <a className="rounded-pill header_a" href="#/" onClick={(e) => e.preventDefault()}>
                                            {this.state.lang_version === "en" ? "Members" : "成员"}
                                            <span className="opacity-5 dropdown-arrow">
                                                <FontAwesomeIcon icon={['fas', 'angle-down']} />
                                            </span>
                                        </a>
                                        <div className="submenu-dropdown">
                                            <div className="shadow-lg bg-white rounded">
                                                {this.getNavList("member")}
                                            </div>
                                        </div>
                                    </li>
                                    <li name="donate">
                                        <a className="rounded-pill header_a" href="#/" onClick={(e) => e.preventDefault()}>
                                            {this.state.lang_version === "en" ? "Donate" : "捐赠"}

                                            <span className="opacity-5 dropdown-arrow">
                                                <FontAwesomeIcon icon={['fas', 'angle-down']} />
                                            </span>
                                        </a>
                                        <div className="submenu-dropdown">
                                            <div className="shadow-lg bg-white rounded">
                                                {this.getNavList("donate")}
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                            <div className="header-nav-actions flex-grow-0 flex-lg-grow-1" style={{ display: "none" }}>
                                <span className="d-none d-lg-block">
                                    <form action="https://checkout.globalgatewaye4.firstdata.com/pay" id="pay_now_form_8b4f1fcbb5" method="post" target="_blank">
                                        <input type="hidden" name="x_login" value="WSP-HUAXI-8HdcpwCW9w" />
                                        <input type="hidden" name="x_show_form" value="PAYMENT_FORM" />
                                        <input type="hidden" name="x_fp_sequence" value="15053941031240394964" />
                                        <input type="hidden" name="x_fp_hash" value="PNB-1.0-c80f47569e1c44c377e2c08fa5e1e79d52fe656c" />
                                        <input type="hidden" name="x_amount" />
                                        <input type="hidden" name="x_currency_code" value="USD" />
                                        <input type="hidden" name="x_test_request" value="FALSE" />
                                        <input type="hidden" name="x_relay_response" value="" />
                                        <input type="hidden" name="donation_prompt" />
                                        <input type="hidden" name="button_code" value="Pay Now HuaXia Chinese Chorus" />
                                    </form>
                                </span>
                            </div>
                            <MainHeaderUser lang_version={this.state.lang_version} updateLangVersion={() => this.updateLangVersion()} />
                            <div className="d-flex d-lg-none">
                                <Collapse
                                    isOpen={this.state.collapse}
                                    className="nav-collapsed-wrapper navbar-collapse">
                                    <div className="nav-inner-wrapper">
                                        <Button
                                            onClick={() => this.handleMobileToggle()}
                                            color="danger"
                                            className="btn-icon d-40 shadow-sm hover-scale-lg btn-animated-icon-sm nav-toggle-inner-btn p-0">
                                            <span className="btn-wrapper--icon">
                                                <FontAwesomeIcon icon={['fas', 'times']} />
                                            </span>
                                        </Button>
                                        <Nav pills className="nav-neutral-primary nav-pills-rounded nav-lg flex-column p-3">
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "about")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "About Us" : "关于我们"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                                {this.state.collapse_show === "about" && this.getNavList("about")}
                                            </NavItem>
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "highlights")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Highlights" : "感动瞬间"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                            </NavItem>
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "events")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Events" : "动态"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                            </NavItem>
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "gallery")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Gallery" : "图库"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                            </NavItem>
                                            {isLogin &&<NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "resource")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Resources" : "资源"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                            </NavItem>}
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "members")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Members" : "成员"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                                {this.state.collapse_show === "members" && this.getNavList("member")}

                                            </NavItem>
                                            <NavItem>
                                                <NavLinkStrap
                                                    href="#/"
                                                    onClick={(e) => this.handleNavClick(e, "donate")}
                                                    className="px-4 d-flex align-items-center">
                                                    <span>{this.state.lang_version === "en" ? "Donate" : "捐赠"}</span>
                                                    <FontAwesomeIcon
                                                        icon={['fas', 'angle-right']}
                                                        className="opacity-6 ml-auto"
                                                    />
                                                </NavLinkStrap>
                                                {this.state.collapse_show === "donate" && this.getNavList("donate")}
                                            </NavItem>
                                        </Nav>
                                    </div>
                                </Collapse>
                            </div>
                        </div>
                        {/* <div
                        className={clsx('collapse-page-trigger', { 'is-active': this.state.collapse })}
                        onClick={()=>this.handleMobileToggle()}
                    /> */}
                    </div>
                    <div classsName="" style={{ paddingTop: "80px", minHeight: "100vh" }}>
                        {(this.state.option === "all" || this.state.option === "about_us" || this.state.option === "contact_us" || this.state.option === "highlights") &&
                            <div className="container" style={{ maxWidth: "1200px" }}>
                                {this.state.home !== null && <HomeHeroImages images={this.state.home.hero_images} />}
                                <div className="container pt-5" style={{ maxWidth: "1200px" }}>
                                    <HighLightInfo handleViewSingleEvent={(id) => this.handleViewSingleEvent(id)} lang_version={this.state.lang_version} />
                                    {this.state.home !== null && <Card className="card-box mb-5 mt-3" id="about_us">
                                        <Row className="no-gutters">
                                            <Col lg="5">
                                                <img alt="..." className="rounded br-lg-right-0 img-fit-container" src={this.state.home.about_us.image} />
                                            </Col>
                                            <Col lg="7">
                                                <div className="px-5 pb-5">
                                                    <a href="#/" onClick={e => e.preventDefault()}>
                                                        <h3 className="display-3 my-3 font-weight-bold">
                                                            {this.state.lang_version === "ch" ? this.state.home.about_us.title_ch : this.state.home.about_us.title_en}
                                                        </h3>
                                                    </a>
                                                    <div className="mb-4 font-size-lg text-black" dangerouslySetInnerHTML={{ __html: this.state.lang_version === "en" ? this.state.home.about_us.info_en : this.state.home.about_us.info_ch }} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>}

                                    <div name="contact_us" id="contact_us" className="container pb-5">
                                        <Card className="card-box text-center pb-4">
                                            <span className="ribbon-horizontal ribbon-horizontal--first"><span>{this.state.lang_version === "en" ? "Contact US" : "联系我们"}</span></span>
                                            <div className="pt-5">
                                                <h3 className="font-size-lg font-weight-bold mt-5 mb-4 px-3"><span>{this.state.lang_version === "ch" ? "联系我们: " : "Contact Huaxia: "}</span> ContactHX@HXChorus.org</h3>
                                                <p className="card-text px-5 mb-4">

                                                </p>
                                                <h3 className="font-size-lg font-weight-bold mt-5 mb-4 px-3"><span>{this.state.lang_version === "ch" ? "加入我们: " : "For joining Huaxia, contact "}</span>JoinHX@HXChorus.org</h3>
                                                <h3 className="font-size-lg font-weight-bold mt-5 mb-4 px-3"><span>{this.state.lang_version === "ch" ? "关于捐款和税务问题: " : "For donation to Huaxia or tax questions, contact "}</span> DonateToHX@HXChorus.org</h3>
                                                <h3 className="font-size-lg font-weight-bold mt-5 mb-4 px-3"><span>{this.state.lang_version === "ch" ? "残疾人士帮助 : " : "For ADA (America Disability Act) related assistance, contact "}</span> HXC_ADA@HXChorus.org</h3>

                                            </div>
                                        </Card>
                                    </div>

                                </div>
                            </div>
                        }
                        {this.state.option === "gallery" && <GalleryShow />}
                        {this.state.option === "events" && <EventsList handleViewSingleEvent={(id) => this.handleViewSingleEvent(id)} lang_version={this.state.lang_version} />}
                        {this.state.option === "single_event" && <SingleEventProfile id={this.state.event_id} lang_version={this.state.lang_version} />}
                        {(this.state.option === "conductor" || this.state.option === "advisor" || this.state.option === "instructor" || this.state.option === "member" || this.state.option === "committee") && <MemberProfile user_role={this.state.option} lang_version={this.state.lang_version} />}
                        {this.state.option === "resource" && <FileInstance pid={this.state.file_id} searchValue="" lang_version={this.state.lang_version} show_search_bar={true} />}
                        {(this.state.option === "law" || this.state.option === "donation_introduction" || this.state.option === "donation_letter" || this.state.option === "regulation") && <div class="mb-3 mt-2 card" style={{ maxWidth: "1200px", margin: "auto", minHeight: "100vh" }}><InfoModal option={this.state.option} lang_version={this.state.lang_version} /></div>}
                    </div>
                    {this.state.option === "all" && <div name="sponsor" style={{ cursor: "pointer" }} className="text-center pb-2 pt-2" onClick={(e) => this.goToSponsor()}>
                        <span style={{fontSize:"16px"}}>{"Foundings has been made possible in part by funds from Morris arts through the New Jersey State Council on the arts Department of State, a Partner Agency of the National Endowment for the Arts"}</span><br />
                        <img src={sponsor_logo} alt="" />
                    </div>}
                    {getFileUploadUI()}

                </div>
            </Fragment>
        );
    }
}
